module.exports = __webpack_public_path__ + "img/img-2-4mobile.c97b21d4.png";